var map; // finally, map is global var;)

function new_map($el, zoom) {

	var $markers = $el.find('.marker');

	var args = {
		center: new google.maps.LatLng(44.701263, 8),
		zoom: zoom,
		draggable: true,
		scrollwheel: false,
		disableDoubleClickZoom: false,
		panControl: true,
		zoomControl: true,
		scaleControl: false,
		mapTypeControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		backgroundColor: '#ffffff'
	};

	map = new google.maps.Map( $el[0], args);

	map.markers = [];

	var styles = [{"featureType":"all","elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"featureType":"all","elementType":"geometry","stylers":[{"color":"#fbc43a"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#808080"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#808080"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#808080"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#808080"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#fbc43a"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"off"},{"color":"#92998d"}]}];

	var styledMapOptions = {
		map: map
	}

	var mainmap = new google.maps.StyledMapType(styles,styledMapOptions);

	map.mapTypes.set('site_map', mainmap);
	map.setMapTypeId('site_map');

	$markers.each(function(){
    	add_marker( jQuery(this), map );
	});

	return map;
}
function add_marker( $marker, map ) {
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	var image = {
		url: 'static/svg/src/icon-pin.svg',
		size: new google.maps.Size(46,56),
		origin: new google.maps.Point(0,0),
		anchor: new google.maps.Point(23,56),
		scaledSize: new google.maps.Size(46,56),
	  };

	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
		icon		: image,
		optimized: false,
	});

	map.markers.push( marker );

	if( $marker.html() ) {
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});
		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open( map, marker );
			$('.marker-content').parent().parent().parent().addClass('marker-wrap');
			$('.marker-content').parent().parent().parent().parent().addClass('marker-wrap-outer');
		});
	}
}
function center_map( map ) {
	var bounds = new google.maps.LatLngBounds();

	jQuery.each( map.markers, function( i, marker ){
		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		bounds.extend( latlng );
	});
	if( map.markers.length == 1 ) {
		map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else {
		map.fitBounds( bounds );
	}
}

jQuery(document).ready(function($){
	$('.gmap').each(function(){
		var zoom = (document.body.clientWidth > 700) ? 2 : 1;
		map = new_map($(this), zoom);
	});
});